export const unknownToAttributeValue = function unknownToAttributeValue(propertyValue) {
    return propertyValue == null ? null : String(propertyValue);
};
export const attributeValueToString = function attributeValueToString(attributeValue) {
    return attributeValue === null ? undefined : attributeValue;
};
export const stringToAttributeValue = function stringToAttributeValue(propertyValue) {
    return propertyValue === undefined ? null : propertyValue;
};
export const attributeValueToBoolean = function attributeValueToBoolean(attributeValue) {
    return attributeValue !== null && attributeValue !== "false";
};
export const booleanToAttributeValue = function booleanToAttributeValue(propertyValue) {
    return propertyValue ? "" : null;
};
export const attributeValueToInteger = function attributeValueToInteger(attributeValue) {
    return attributeValue === null ? undefined : parseInt(attributeValue, 10);
};
export const integerToAttributeValue = function integerToAttributeValue(propertyValue) {
    return propertyValue === undefined ? null : String(propertyValue);
};
export const numberTransformers = {
    toAttributeValue: (propertyValue) => {
        return propertyValue === undefined ? null : String(propertyValue);
    },
    toPropertyValue: (attributeValue) => {
        return attributeValue === null ? undefined : Number(attributeValue);
    },
};
export const integerTransformers = {
    toAttributeValue: integerToAttributeValue,
    toPropertyValue: attributeValueToInteger,
};
export const attributeValueToBigint = function attributeValueToInteger(attributeValue) {
    return attributeValue === null ? undefined : BigInt(attributeValue);
};
export const bigintToAttributeValue = function integerToAttributeValue(propertyValue) {
    return propertyValue === undefined ? null : String(propertyValue);
};
export const bigintTransformers = {
    toAttributeValue: bigintToAttributeValue,
    toPropertyValue: attributeValueToBigint,
};
export const objectTransformers = {
    toAttributeValue: (value) => {
        return value === undefined ? null : JSON.stringify(value);
    },
    toPropertyValue: (value) => {
        return typeof value === "string" ? JSON.parse(value) : undefined;
    },
};
export const booleanTransformers = {
    toAttributeValue: booleanToAttributeValue,
    toPropertyValue: attributeValueToBoolean,
};
export function createNumericTransformers(Constructor) {
    const toPropertyValue = function toPropertyValue(attributeValue) {
        return attributeValue === null
            ? undefined
            : new Constructor(Number(attributeValue));
    };
    const toAttributeValue = function toAttributeValue(propertyValue) {
        return propertyValue === undefined ? null : String(Number(propertyValue));
    };
    return {
        toAttributeValue,
        toPropertyValue,
    };
}
export function stringOrBooleanToAttributeValue(propertyValue) {
    return typeof propertyValue === "boolean"
        ? booleanToAttributeValue(propertyValue)
        : stringToAttributeValue(propertyValue);
}
